import { RoutePrefetchQueryOptions } from '@moment/routes/types.ts';
import { LibraryLicense, License } from '@moment/db/license-db-service.ts';

export type VersionRouteParams = { version: string }

export type OssVersionFetchResponse = LibraryLicense[]

export type OssLibraryLicenseResponse = Array<LibraryLicense & { license: License | null }>

export const generateFetchOssVersionQuery =
  (options?: RoutePrefetchQueryOptions&VersionRouteParams) => {
    return async (): Promise<OssVersionFetchResponse> => {
      const logger = options ? options.logger : undefined
      const version = options ? options.version : undefined

      logger?.log(`generateFetchOssVersionQuery, version = ${version}`)

      const url = `/api/android-oss-version/${version}`

      const res = await fetch(url);

      return await res.json();

    }
  }

export const genereateFetchLibraryLicenseContent = (version: string, libraryName: string) => {
  return async (): Promise<string> => {
    const url = `/api/android-oss-version/${version}/${libraryName}`
    const res = await fetch(url);
    return await res.json();
  }
}
